module.exports = __webpack_public_path__ + "img/keyboard.23b516e8.png";